import { SOCIAL_NETWORK } from '../../../../models/post'
import AltFacebookIcon from './AltFacebook'
import AltInstagramIcon from './AltInstagram'
import AltLinkedinIcon from './AltLinkedin'
import AltTwitterIcon from './AltTwitter'
import FacebookIcon from './Facebook'
import InstagramIcon from './Instagram'
import LinkedinIcon from './Linkedin'
import TwitterIcon from './Twitter'

type TSocialIcons = {
  [key in SOCIAL_NETWORK]: React.ReactElement
}

export const OriginalSocialIcons: TSocialIcons = {
  [SOCIAL_NETWORK.FACEBOOK_SOCIAL]: <FacebookIcon />,
  [SOCIAL_NETWORK.INSTAGRAM_SOCIAL]: <InstagramIcon />,
  [SOCIAL_NETWORK.LINKEDIN_SOCIAL]: <LinkedinIcon />,
  [SOCIAL_NETWORK.TWITTER_SOCIAL]: <TwitterIcon />
}

export const AltSocialIcons: TSocialIcons = {
  [SOCIAL_NETWORK.FACEBOOK_SOCIAL]: <AltFacebookIcon />,
  [SOCIAL_NETWORK.INSTAGRAM_SOCIAL]: <AltInstagramIcon />,
  [SOCIAL_NETWORK.LINKEDIN_SOCIAL]: <AltLinkedinIcon />,
  [SOCIAL_NETWORK.TWITTER_SOCIAL]: <AltTwitterIcon />
}
